export const containerTypeValues = [
  "keg",
  "can",
  "cask",
  "bottle",
  "bagInBox",
] as const;

export type ContainerDiscountContainerType =
  (typeof containerTypeValues)[number];

export const containerTypeOptions: Array<{
  value: ContainerDiscountContainerType;
  label: string;
}> = [
  { value: "keg", label: "Keg" },
  { value: "cask", label: "Cask" },
  { value: "can", label: "Cases of cans" },
  { value: "bottle", label: "Cases of bottles" },
  { value: "bagInBox", label: "Bag In Box" },
];

export const getContainerTypeLabel = (
  value: ContainerDiscountContainerType,
): string => {
  return (
    containerTypeOptions.find((option) => option.value === value)?.label ??
    value
  );
};
